type MessageTree = Record<string, unknown>

/** Deep-merge localized messages over a base catalog (missing keys fall back to base). */
export function mergeMessages(
  base: MessageTree,
  override: MessageTree,
): MessageTree {
  const merged: MessageTree = { ...base }

  for (const [key, value] of Object.entries(override)) {
    const existing = merged[key]
    if (
      value &&
      typeof value === "object" &&
      !Array.isArray(value) &&
      existing &&
      typeof existing === "object" &&
      !Array.isArray(existing)
    ) {
      merged[key] = mergeMessages(
        existing as MessageTree,
        value as MessageTree,
      )
      continue
    }
    merged[key] = value
  }

  return merged
}
